import { Box, Card, Typography } from "@mui/material";
import { WEEK_DAYS } from "../../shared";

export function DayCards() {
  return (
    <Box
      sx={{
        display: "grid",
        gap: 2,
        // < lg: equal columns, at most 4, fewer once a quarter drops under 140px
        // lg+: the 7 days on a single row
        gridTemplateColumns: {
          xs: "repeat(auto-fit, minmax(max(140px, calc((100% - 48px) / 4)), 1fr))",
          lg: "repeat(7, 1fr)",
        },
      }}
    >
      {WEEK_DAYS.map((day) => (
        <Card
          key={day.label}
          sx={{
            pt: 0,
            pb: 2,
            px: 2,
            textAlign: "center",
            opacity: day.type ? 1 : 0.5,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {day.label}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {day.hours}
          </Typography>
          {day.type && (
            <Typography variant="caption" sx={{ color: "#ffffff", fontWeight: 700 }}>
              {day.type}
            </Typography>
          )}
        </Card>
      ))}
    </Box>
  );
}
